import { connect } from 'react-redux';
import {
  reduxForm,
  initialize as initializeForm,
  reset as resetForm
} from 'redux-form';

import { getPropertyDetailsAttributeGroups } from 'legacy/utils/property-details';

import { propertyQueryDetailsComplete } from 'actions/property';
import {
  vrEditPropertyDetails,
  vrEditPropertyDetailsRevert,
  valueReportSubjectAdjustPropertyDetails
} from 'actions/edit-report';

import {
  getSubjectAdjusted,
  getSubjectAdjustments,
  getSubjectFormValuesChanged
} from 'selectors/subject';
import {
  getIsEditingSubject,
  getIsEffectiveDateReport
} from 'selectors/property-explorer';
import { getReportStatusIsRecomputing } from 'selectors/report-status';
import { getIsReportEditable } from 'selectors/report-permissions';

import addressIdRequired from 'legacy/hocs/addressIdRequired';
import dispatchOnMount from 'legacy/hocs/dispatchOnMount';

import PropertyDetailsGeneral from 'legacy/components/PropertyDetailsGeneral';

const mapStateToProps = (state, ownProps) => {
  const { addressId } = ownProps;
  const property = addressId === 'subject' ? getSubjectAdjusted(state) : {};
  const changedValues = getSubjectFormValuesChanged(state);
  const propertyUpdated = { ...property, ...changedValues };
  return {
    isEffectiveDateReport: getIsEffectiveDateReport(state),
    form: 'propertyExplorerPropertyDetails',
    initialValues: { ...property },
    recomputing: getReportStatusIsRecomputing(state),
    adjustments: getSubjectAdjustments(state),
    attributeGroups: getPropertyDetailsAttributeGroups(propertyUpdated),
    editing: getIsEditingSubject(state),
    editable: getIsReportEditable(state),
    property: propertyUpdated,
    changedValues
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { addressId } = ownProps;
  return {
    onAdjust: (form, property) => {
      dispatch(initializeForm(form, property));
      dispatch(vrEditPropertyDetails());
    },
    onSubmit: (adjustments, property, form) => {
      dispatch(valueReportSubjectAdjustPropertyDetails(adjustments));
      // Reinit form w/ updated values
      dispatch(initializeForm(form, { ...property, ...adjustments }));
    },
    onCancel: () => {
      dispatch(vrEditPropertyDetailsRevert());
      dispatch(resetForm('propertyExplorerPropertyDetails'));
    },
    onMount: (form, property) => {
      dispatch(propertyQueryDetailsComplete(addressId));
      dispatch(initializeForm(form, property));
    }
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { changedValues, form, property } = stateProps;
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onSubmit: () => dispatchProps.onSubmit(changedValues, property, form),
    onAdjust: () => dispatchProps.onAdjust(form, property),
    onMount: () => dispatchProps.onMount(form, property)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(reduxForm()(addressIdRequired(dispatchOnMount(PropertyDetailsGeneral))));
